import { createStore } from 'redux';
import reducers from './reducers';

const store = createStore(reducers);
window.ReduxStore = store;
export default store;